// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ipf-date-time-picker__date-time-wrapper {
  border: 1px solid #dfe0e4;
  border-radius: 3px;
  width: 330px;
  padding: 12px 15px;
  display: inline-block;
}

.ipf-date-time-picker__date-time-toolbar-button-icon {
  color: #fff;
  height: 28px;
  margin-bottom: 2px;
  line-height: 28px;
  display: block;
}

.ipf-date-time-picker__date-time-toolbar-button {
  background: var(--info);
  border: 1px solid var(--info);
  color: #fff;
  cursor: pointer;
  text-align: center;
  z-index: 5;
  border-radius: 50%;
  outline: 0;
  width: 30px;
  height: 30px;
  padding: 0;
  font-size: 1.5em;
  line-height: 30px;
  position: relative;
}

.ipf-date-time-picker__date-time-toolbar {
  color: var(--info);
  text-align: center;
  margin-bottom: 13px;
  line-height: 30px;
}

.ipf-date-time-picker__date-time-time-next {
  color: var(--info);
  margin-top: 7px;
  margin-bottom: 10px;
  font-size: 15px;
  position: relative;
  left: -10px;
}

.ipf-date-time-picker__date-time-table-border {
  color: #555;
  cursor: pointer;
  text-align: center;
  border: 1px solid #dfe0e4;
  padding: 8px 0;
  font-size: 1.2em;
}

.ipf-date-time-picker__date-time-table-border:hover {
  background: var(--info);
  color: #fff;
}

.ipf-date-time-picker__date-time-table-border--current-day {
  color: var(--info);
}

.ipf-date-time-picker__date-time-table-border--month {
  color: #999;
}

.ipf-date-time-picker__date-time-table-border-thead {
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 700;
}

.ipf-date-time-picker__date-time-table {
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  width: 100%;
}

.ipf-date-time-picker__date-time-tab {
  height: 310px;
}

.ipf-date-time-picker__date-time-show-time-time {
  background-color: var(--info);
  color: #fff;
  text-align: center;
  border-radius: 3px;
  width: 65px;
  height: 65px;
  font-size: 38px;
  line-height: 65px;
  display: inline-block;
}

.ipf-date-time-picker__date-time-show-time-separator {
  color: var(--info);
  text-align: center;
  width: 32px;
  height: 65px;
  font-size: 32px;
  font-weight: 700;
  line-height: 65px;
  display: inline-block;
}

.ipf-date-time-picker__date-time-show-time {
  text-align: center;
  padding-top: 70px;
}

.ipf-date-time-picker__date-time-current-date {
  color: var(--info);
  font-size: 1.2em;
}

.ipf-date-time-picker__date-time-picker-wrapper {
  background: #fff;
  flex-direction: column;
  padding: 10px;
  display: flex;
}

.ipf-date-time-picker__date-time-input {
  border: 1px solid #dfe0e4;
  border-radius: 3px;
  outline: 0;
  width: 100%;
  padding: 5px 10px;
  position: relative;
}

.ipf-date-time-picker__date-time-close-button-bg {
  background-color: var(--info);
  cursor: pointer;
  float: right;
  border-radius: 50%;
  align-self: flex-end;
  width: 20px;
  height: 20px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}

.ipf-date-time-picker__date-time-close-button-cross {
  z-index: 100;
  width: 10px;
  height: 10px;
  position: absolute;
  top: 5px;
  left: 5px;
  transform: rotate(45deg);
}

.ipf-date-time-picker__date-time-close-button-cross:before {
  content: "";
  background-color: #fff;
  width: 2px;
  height: 10px;
  position: absolute;
  top: 0;
  left: 4px;
}

.ipf-date-time-picker__date-time-close-button-cross:after {
  content: "";
  background-color: #fff;
  width: 10px;
  height: 2px;
  position: absolute;
  top: 4px;
  left: 0;
}

.ipf-date-time-picker__date-time-button {
  background-color: var(--info);
  color: #fff;
  text-align: center;
  cursor: pointer;
  border: 0;
  border-radius: 3px;
  outline: 0;
  width: 100%;
  margin-top: 10px;
  padding: 12px 0;
  font-size: 16px;
  line-height: 1;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/DateTimePicker/dateTimePicker.css","webpack://./services/frontend/app/components/DateTimePicker/dateTimePicker.css"],"names":[],"mappings":"AADA;ECEE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,SAAS;AACX;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB","sourcesContent":[".ipf-date-time-picker__date-time-wrapper {\n  border-radius: 3px;\n  border: 1px solid #dfe0e4;\n  display: inline-block;\n  padding: 12px 15px;\n  width: 330px;\n}\n\n.ipf-date-time-picker__date-time-toolbar-button-icon {\n  color: #fff;\n  display: block;\n  height: 28px;\n  line-height: 28px;\n  margin-bottom: 2px;\n}\n\n.ipf-date-time-picker__date-time-toolbar-button {\n  background: var(--info);\n  border-radius: 50%;\n  border: 1px solid var(--info);\n  color: #fff;\n  cursor: pointer;\n  font-size: 1.5em;\n  height: 30px;\n  line-height: 30px;\n  outline: 0;\n  padding: 0;\n  position: relative;\n  text-align: center;\n  width: 30px;\n  z-index: 5;\n}\n\n.ipf-date-time-picker__date-time-toolbar {\n  line-height: 30px;\n  color: var(--info);\n  text-align: center;\n  margin-bottom: 13px;\n}\n\n.ipf-date-time-picker__date-time-time-next {\n  color: var(--info);\n  font-size: 15px;\n  left: -10px;\n  margin-bottom: 10px;\n  margin-top: 7px;\n  position: relative;\n}\n\n.ipf-date-time-picker__date-time-table-border {\n  border: 1px solid #dfe0e4;\n  color: #555;\n  cursor: pointer;\n  font-size: 1.2em;\n  padding: 8px 0;\n  text-align: center;\n}\n\n.ipf-date-time-picker__date-time-table-border:hover {\n    background: var(--info);\n    color: #fff;\n  }\n\n.ipf-date-time-picker__date-time-table-border--current-day {\n  color: var(--info);\n}\n\n.ipf-date-time-picker__date-time-table-border--month {\n  color: #999;\n}\n\n.ipf-date-time-picker__date-time-table-border-thead {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.ipf-date-time-picker__date-time-table {\n  border-collapse: collapse;\n  border-spacing: 0;\n  table-layout: fixed;\n  width: 100%;\n}\n\n.ipf-date-time-picker__date-time-tab {\n  height: 310px;\n}\n\n.ipf-date-time-picker__date-time-show-time-time {\n  background-color: var(--info);\n  border-radius: 3px;\n  color: #fff;\n  display: inline-block;\n  font-size: 38px;\n  height: 65px;\n  line-height: 65px;\n  text-align: center;\n  width: 65px;\n}\n\n.ipf-date-time-picker__date-time-show-time-separator {\n  color: var(--info);\n  display: inline-block;\n  font-size: 32px;\n  font-weight: 700;\n  height: 65px;\n  line-height: 65px;\n  text-align: center;\n  width: 32px;\n}\n\n.ipf-date-time-picker__date-time-show-time {\n  padding-top: 70px;\n  text-align: center;\n}\n\n.ipf-date-time-picker__date-time-current-date {\n  color: var(--info);\n  font-size: 1.2em;\n}\n\n.ipf-date-time-picker__date-time-picker-wrapper {\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n}\n\n.ipf-date-time-picker__date-time-input {\n  border-radius: 3px;\n  border: 1px solid #dfe0e4;\n  outline: 0;\n  padding: 5px 10px;\n  position: relative;\n  width: 100%;\n}\n\n.ipf-date-time-picker__date-time-close-button-bg {\n  align-self: flex-end;\n  background-color: var(--info);\n  border-radius: 50%;\n  cursor: pointer;\n  float: right;\n  height: 20px;\n  margin: 0 auto;\n  overflow: hidden;\n  position: relative;\n  width: 20px;\n}\n\n.ipf-date-time-picker__date-time-close-button-cross {\n  height: 10px;\n  left: 5px;\n  position: absolute;\n  top: 5px;\n  transform: rotate(45deg);\n  width: 10px;\n  z-index: 100;\n}\n\n.ipf-date-time-picker__date-time-close-button-cross:before {\n    background-color: #fff;\n    content: '';\n    height: 10px;\n    left: 4px;\n    position: absolute;\n    top: 0;\n    width: 2px;\n  }\n\n.ipf-date-time-picker__date-time-close-button-cross:after {\n    background-color: #fff;\n    content: '';\n    height: 2px;\n    left: 0;\n    position: absolute;\n    top: 4px;\n    width: 10px;\n  }\n\n.ipf-date-time-picker__date-time-button {\n  background-color: var(--info);\n  border-radius: 3px;\n  color: #fff;\n  display: block;\n  font-size: 16px;\n  margin-top: 10px;\n  padding: 12px 0;\n  text-align: center;\n  width: 100%;\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n  line-height: 1;\n}\n",".ipf-date-time-picker__date-time-wrapper {\n  border: 1px solid #dfe0e4;\n  border-radius: 3px;\n  width: 330px;\n  padding: 12px 15px;\n  display: inline-block;\n}\n\n.ipf-date-time-picker__date-time-toolbar-button-icon {\n  color: #fff;\n  height: 28px;\n  margin-bottom: 2px;\n  line-height: 28px;\n  display: block;\n}\n\n.ipf-date-time-picker__date-time-toolbar-button {\n  background: var(--info);\n  border: 1px solid var(--info);\n  color: #fff;\n  cursor: pointer;\n  text-align: center;\n  z-index: 5;\n  border-radius: 50%;\n  outline: 0;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  font-size: 1.5em;\n  line-height: 30px;\n  position: relative;\n}\n\n.ipf-date-time-picker__date-time-toolbar {\n  color: var(--info);\n  text-align: center;\n  margin-bottom: 13px;\n  line-height: 30px;\n}\n\n.ipf-date-time-picker__date-time-time-next {\n  color: var(--info);\n  margin-top: 7px;\n  margin-bottom: 10px;\n  font-size: 15px;\n  position: relative;\n  left: -10px;\n}\n\n.ipf-date-time-picker__date-time-table-border {\n  color: #555;\n  cursor: pointer;\n  text-align: center;\n  border: 1px solid #dfe0e4;\n  padding: 8px 0;\n  font-size: 1.2em;\n}\n\n.ipf-date-time-picker__date-time-table-border:hover {\n  background: var(--info);\n  color: #fff;\n}\n\n.ipf-date-time-picker__date-time-table-border--current-day {\n  color: var(--info);\n}\n\n.ipf-date-time-picker__date-time-table-border--month {\n  color: #999;\n}\n\n.ipf-date-time-picker__date-time-table-border-thead {\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.ipf-date-time-picker__date-time-table {\n  border-collapse: collapse;\n  border-spacing: 0;\n  table-layout: fixed;\n  width: 100%;\n}\n\n.ipf-date-time-picker__date-time-tab {\n  height: 310px;\n}\n\n.ipf-date-time-picker__date-time-show-time-time {\n  background-color: var(--info);\n  color: #fff;\n  text-align: center;\n  border-radius: 3px;\n  width: 65px;\n  height: 65px;\n  font-size: 38px;\n  line-height: 65px;\n  display: inline-block;\n}\n\n.ipf-date-time-picker__date-time-show-time-separator {\n  color: var(--info);\n  text-align: center;\n  width: 32px;\n  height: 65px;\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 65px;\n  display: inline-block;\n}\n\n.ipf-date-time-picker__date-time-show-time {\n  text-align: center;\n  padding-top: 70px;\n}\n\n.ipf-date-time-picker__date-time-current-date {\n  color: var(--info);\n  font-size: 1.2em;\n}\n\n.ipf-date-time-picker__date-time-picker-wrapper {\n  background: #fff;\n  flex-direction: column;\n  padding: 10px;\n  display: flex;\n}\n\n.ipf-date-time-picker__date-time-input {\n  border: 1px solid #dfe0e4;\n  border-radius: 3px;\n  outline: 0;\n  width: 100%;\n  padding: 5px 10px;\n  position: relative;\n}\n\n.ipf-date-time-picker__date-time-close-button-bg {\n  background-color: var(--info);\n  cursor: pointer;\n  float: right;\n  border-radius: 50%;\n  align-self: flex-end;\n  width: 20px;\n  height: 20px;\n  margin: 0 auto;\n  position: relative;\n  overflow: hidden;\n}\n\n.ipf-date-time-picker__date-time-close-button-cross {\n  z-index: 100;\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  transform: rotate(45deg);\n}\n\n.ipf-date-time-picker__date-time-close-button-cross:before {\n  content: \"\";\n  background-color: #fff;\n  width: 2px;\n  height: 10px;\n  position: absolute;\n  top: 0;\n  left: 4px;\n}\n\n.ipf-date-time-picker__date-time-close-button-cross:after {\n  content: \"\";\n  background-color: #fff;\n  width: 10px;\n  height: 2px;\n  position: absolute;\n  top: 4px;\n  left: 0;\n}\n\n.ipf-date-time-picker__date-time-button {\n  background-color: var(--info);\n  color: #fff;\n  text-align: center;\n  cursor: pointer;\n  border: 0;\n  border-radius: 3px;\n  outline: 0;\n  width: 100%;\n  margin-top: 10px;\n  padding: 12px 0;\n  font-size: 16px;\n  line-height: 1;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
